import type { SxProps, Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import { ListItemButton, ListItemIcon } from '@mui/material';
import { NavLink } from 'react-router-dom';

import type { ReactNode } from 'react';

export type StyledNavItemProps = {
    to: string;
    children?: ReactNode;
    onClick?: () => void;
    sx?: SxProps<Theme>;
    /** Injected by styled(); must be forwarded for the generated styles to apply. */
    className?: string;
};

// `component` is bound here rather than at the call site: MUI's polymorphic prop does not
// survive styled(), so the router link is wired in once, where it can be typed.
export const StyledNavItem = styled(({ to, children, onClick, sx, className }: StyledNavItemProps) => (
    <ListItemButton disableGutters component={ NavLink } to={ to } onClick={ onClick } sx={ sx }
                    className={ className }>
        { children }
    </ListItemButton>
))(({ theme }) => ({
    ...theme.typography.body2,
    height: 44,
    gap: theme.spacing(1.5),
    padding: theme.spacing(0, 1.5),
    position: 'relative',
    textTransform: 'capitalize',
    fontWeight: 600,
    color: '#4F5B67',
    borderRadius: 10,
}));

export const StyledNavItemIcon = styled(ListItemIcon)({
    minWidth: 0,
    width: 20,
    height: 20,
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});
